import React from "react";
import styles from "../ProductDetailsComp/ProductDetails.module.scss";
import Srcset from "../common/Srcset";

// show fast shipping message if the product has fast shipping tag
const FastShippingMessage = ({ tags }) => {
  return (
    <>
      {tags?.includes("Tag:Fast shipping") && (
        <div className={`${styles.fast_shipping_wrapper}`}>
          <span className={`${styles.fast_shipping_icon}`}>
            <Srcset
              requirePath={true}
              svgFile={true}
              src={"images/Icons/Fast-Shipping.png"}
              alt="Fast Shipping"
              height={15}
              className={`${styles.fast_shipping_img}`}
            />
          </span>
          <span
            className={`x-small-sm x-small-xs x-small-md  ${styles.fast_shipping_text}`}
          >
            Fast Shipping
          <span className={`fast_shipping_dot ${styles.fast_shipping_indicator}`}></span>
          </span>
        </div>
      )}
    </>
  );
};

export default FastShippingMessage;
